<script>
    import Loader from "../Loader.svelte";
    import AssessmentTypeModel from "../../Models/assessmentTypeModel";
    import AssessmentTypeNav from "../AssessmentTypeNav.svelte";

    import {notifier} from "@beyonk/svelte-notifications";

    export let params;
    let assessment_type_model, assessment_type;

    function loadAssessmentType(assessment_type_id) {
        assessment_type_model = new AssessmentTypeModel(assessment_type_id);
        assessment_type = assessment_type_model.store;
    }

    function saveAssessmentType(evt) {
        let assessment_type_name = evt.target.name.value;
        let assessment_type_category = evt.target.category.value;
        let production = evt.target.production.checked;

        let details = $assessment_type.details;

        details.name = assessment_type_name;
        details.assessment_type_category = assessment_type_category;
        details.production = production;

        assessment_type_model.saveDetails(details).then(() => {
            notifier.success("Assessment Type Updated");
        });
    }

    $: loadAssessmentType(params.id);
</script>

<Loader loading={!$assessment_type}>
    <div class="container viewport is-fluid">
        <div class="columns">
            <div class="column is-3">
                <AssessmentTypeNav assessment_type_id={params.id}></AssessmentTypeNav>
                <h1 class="title is-1">{$assessment_type.details.name}</h1>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <form on:submit|preventDefault={saveAssessmentType}>
                    <div class="field">
                        <label class="label is-large">Assessment Type Name</label>
                        <div class="control">
                            <input name="name" class="input is-large" type="text" value={$assessment_type.details.name}>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label is-large">Assessment Type Category</label>
                        <div class="control">
                            <div class="select is-large">
                                <select name="category" value={$assessment_type.details.assessment_type_category}>
                                    <option selected>Risk Assessment</option>
                                    <option>Controls Assessment</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <label class="checkbox is-large">
                                <input name="production" type="checkbox" checked={$assessment_type.details.production}>
                                Production Ready
                            </label>
                        </div>
                    </div>
                    <button class="button is-pulled-right is-success">Save</button>
                </form>
            </div>
        </div>
    </div>
</Loader>
